import { render } from "./Maintenances.vue?vue&type=template&id=6841d00e"
import script from "./Maintenances.vue?vue&type=script&lang=js"
export * from "./Maintenances.vue?vue&type=script&lang=js"
script.render = render

export default script